import { FC, useCallback, useState } from 'react'
import Modal from '../Modal'
import siteConfig from 'config'

interface Props {
  open: boolean
  close: () => void
  signInWithEmailLink: (email: string) => Promise<void>
}

const AuthModalContent: FC<Props> = ({ open, close, signInWithEmailLink }) => {
  const [sendingEmail, setSendingEmail] = useState(false)
  const [emailSent, setEmailSent] = useState(false)

  const modalClose = useCallback(() => {
    if (sendingEmail) {
      return
    }
    setEmailSent(false)
    setSendingEmail(false)
    close()
  }, [sendingEmail, close])

  return (
    <Modal open={open} close={modalClose}>
      <div className="grid gap-y-1 text-center">
        {!sendingEmail && emailSent ? (
          <>
            <header className="text-lg font-bold text-kura">{siteConfig.labels.auth.emailSent}</header>
            <p className="text-sm text-kura">{siteConfig.labels.auth.emailSentBody}</p>
          </>
        ) : sendingEmail ? (
          <>
            <header className="text-lg font-bold text-kura">{siteConfig.labels.auth.sendingEmail}</header>
            <p className="text-sm text-kura">{siteConfig.labels.auth.waiting}</p>
          </>
        ) : (
          <>
            <header className="text-lg font-bold text-kura">{siteConfig.labels.auth.signInTitle}</header>
            <p className="text-sm text-kura">{siteConfig.labels.auth.signInBody}</p>
            <form
              className="grid gap-4 py-3"
              onSubmit={(e) => {
                e.preventDefault()
                const email = e.currentTarget.email.value
                setSendingEmail(true)
                signInWithEmailLink(email)
                  .then(() => {
                    setEmailSent(true)
                  })
                  .finally(() => {
                    setSendingEmail(false)
                  })
                return false
              }}
            >
              <input type="email" name="email" disabled={sendingEmail} placeholder="Email" className="input-primary" />
              <button type="submit" disabled={sendingEmail} className="button-primary">
                {siteConfig.labels.auth.submitButton}
              </button>
            </form>
          </>
        )}
      </div>
    </Modal>
  )
}

export default AuthModalContent
